import Navbar1 from "./Navbar1";
import "./NavbarInstance.css";

const NavbarInstance = () => {
  return (
    <header className="navbar-instance1">
      <Navbar1 />
      <div className="c-r-e-a-t-e-y-o-u-r-d-a-t-a-t">
        <h1 className="tradeforge2">
          <span>{` `}</span>
          <span className="tradeforge3">{`TradeForge `}</span>
        </h1>
      </div>
    </header>
  );
};

export default NavbarInstance;
